import React, { useState, useEffect } from 'react';
import { useLang } from '../contexts/LangContext';
import './InstallPrompt.css';

const DISMISS_KEY = 'tcm_install_prompt_dismissed_at';
const DISMISS_DAYS = 14;

function isIos() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}

function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

const ShareIcon = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', margin: '0 2px' }}>
    <path d="M12 16V4M8 8l4-4 4 4" />
    <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7" />
  </svg>
);

export default function InstallPrompt() {
  const { lang } = useLang();
  const pt = lang === 'pt';
  const [visible, setVisible] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const ios = isIos();

  useEffect(() => {
    if (isStandalone()) return;

    function mostrarPorTour() {
      if (!isStandalone()) setVisible(true);
    }
    window.addEventListener('tcm:show-install-prompt', mostrarPorTour);

    const dismissedAt = localStorage.getItem(DISMISS_KEY);
    const recentementeDispensado = dismissedAt && (Date.now() - Number(dismissedAt)) / 86400000 < DISMISS_DAYS;

    function handleBeforeInstall(e) {
      e.preventDefault();
      setDeferredPrompt(e);
      if (!recentementeDispensado) setVisible(true);
    }
    window.addEventListener('beforeinstallprompt', handleBeforeInstall);

    let timer;
    if (ios && !recentementeDispensado) {
      timer = setTimeout(() => setVisible(true), 2500);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
      window.removeEventListener('tcm:show-install-prompt', mostrarPorTour);
      clearTimeout(timer);
    };
  }, [ios]);

  function dismiss() {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  }

  async function handleInstallClick() {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
    }
    dismiss();
  }

  if (!visible) return null;

  return (
    <div className="install-prompt-wrap">
      <div className="install-prompt-card">
        <button className="install-prompt-close" onClick={dismiss} aria-label="Fechar">×</button>
        <img className="install-prompt-icon" src="/icon-192.png" alt="" width="40" height="40" />
        <div className="install-prompt-body">
          <div className="install-prompt-title">
            {pt ? 'Salve o app na tela inicial' : 'Save the app to your home screen'}
          </div>
          <div className="install-prompt-text">
            {ios
              ? (pt
                ? <>Toque em <ShareIcon />Compartilhar e depois em <strong>"Adicionar à Tela de Início"</strong>.</>
                : <>Tap <ShareIcon />Share, then <strong>"Add to Home Screen"</strong>.</>)
              : (pt
                ? 'Acesse seus treinos e dieta mais rápido, como um app.'
                : 'Access your workouts and diet faster, like an app.')}
          </div>
        </div>
        {!ios && (
          <button className="install-prompt-btn" onClick={handleInstallClick}>
            {pt ? 'Instalar' : 'Install'}
          </button>
        )}
      </div>
    </div>
  );
}
